import moment from 'moment-timezone';
import 'moment/locale/ja';
import 'moment/locale/th';

export const changeLocale = (lng) => {
  moment.locale(lng === 'jp' ? 'ja' : lng);
};
